import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';
import { SeoService } from 'src/services/seo/seo.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  aboutList = new Array(14).map((e: any) => e.fill(0));

  /**
   * Creates an instance of about component.
   * @param commonService
   */
  constructor(public commonService: CommonService, private seoService: SeoService) {}

  ngOnInit(): void {
    this.seoService.setMetaTags(
      'About Outlive Chat, Online Mental Health Support',
      'Get to know about Outlive Chat and how our online mental health support offers a safe, confidential space where young people can connect and be heard.'
    );
  }
}
